export class Todo {
    id:number;
    title:string;
    completed:boolean;
}